<template>
  <div>
    <section class="container">
      <div class="section-group">
        <div class="row">
          <div class="col-lg-3">
            <UserFeedInfoVue props_selectItem="group"></UserFeedInfoVue>
          </div>
          <div class="col-lg-6">
            <div
              :style="{
                'background-image': `url(${backImg})`,
              }"
              style="opacity: 0.3;height: 600px;width: 100%;background-size: cover;z-index: 1;display: inline-block;position: absolute;"
            ></div>
            <div
              class="row clearfix bg_switch"
              :style="{ 'background-color': backColor, color: fontColor }"
            >
              <div class="col-lg-12">
                <div class="card chat-app" style="margin-bottom: 0 !important">
                  <div class="without_opacity">
                    <!-- 右側群組內容 -->
                    <div class="chat-header ">
                    <!-- <div class="chat-header clearfix"> -->
                      <div class="row">
                        <div class="col-12 mt-3">
                          <a
                            href="javascript:;"
                            data-toggle="modal"
                            data-target="#view_info"
                          >
                            <div
                              class="Ingroup_BgIMG"
                              :style="{
                                'background-image': `url(${dataInfo.sgL_Logo})`,
                              }"
                            ></div>
                          </a>
                          <div class="chat-about">
                            <h6 class="mt-3 f-bold">
                              {{ dataInfo.sgL_GroupName }}
                            </h6>
                          </div>
                          <div class="col-lg-12 hidden-sm text-right">
                            <a
                              href="javascript:"
                              v-if="dataInfo.sgL_UsersId === loginUser.userId"
                              @click="
                                $router.push({
                                  name: 'feedGroup_groupSetting',
                                  query: { id: $route.query.sgL_GroupId },
                                })
                              "
                              class="btn btn-outline-info"
                              ><i class="fa fa-cogs"></i
                            ></a>
                            <a
                              href="javascript:"
                              @click="showfriend"
                              class="btn btn-outline-info"
                              data-toggle="modal"
                              data-target="#groupfriendlist"
                              ><i class="fas fa-address-book"></i
                            ></a>
                          </div>
                          <div
                            class="Ingroup_des"
                            v-if="dataInfo.sgL_GroupContent"
                          >
                            <span v-if="!AllsgL_GroupContent"
                              >{{ dataInfo.sgL_GroupContent.slice(0, 30)
                              }}{{
                                dataInfo.sgL_GroupContent.length > 30
                                  ? "..."
                                  : ""
                              }}</span
                            ><span v-else>{{ dataInfo.sgL_GroupContent }}</span>
                            <p
                              v-if="dataInfo.sgL_GroupContent.length > 30"
                              @click="
                                AllsgL_GroupContent = !AllsgL_GroupContent
                              "
                            >
                              {{
                                AllsgL_GroupContent ? $t('Social.group.groupDetail.Reducedpresentation') : $t('Social.group.groupDetail.ShowMore')
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 px-lg-2">
                      <div class="row">
                        <div class="col-12">
                          <div id="feed-wall">
                            <div class="feedpost card">
                              <div
                                class="social_feed_date card-body"
                                style="padding: 0"
                              >
                                <el-date-picker
                                  v-model="date"
                                  @change="getPageList(true)"
                                  value-format="yyyy-MM-dd"
                                  type="date"
                                  style="width: 100%"
                                  :placeholder="$t('Social.group.groupDetail.placeholder')"
                                >
                                </el-date-picker>
                              </div>
                            </div>
                            <div
                              v-for="item in pageData"
                              :key="item.id"
                              style="margin: 20px 0"
                            >
                              <div
                                class="feedpost card_group"
                                v-if="item.sgL_Type === 'Content'"
                              >
                                <div class="group_card-body">
                                  <div class="group_feedpost-content">
                                    <!-- user message -->
                                    <p class="message_txt">
                                      {{ item.sgL_Content }}
                                    </p>
                                   <p class="desc_txt" v-if="!item.sgL_IsShow" > {{ $t('Social.group.groupDetail.hidden') }}</p>

                                  </div>

                                  <detailCardVue
                                    :item="item"
                                    :sgL_UsersId="dataInfo.sgL_UsersId"
                                    @addfavorite="addfavorite"
                                    @commentShow="commentShow(item)"
                                    @share="share(item)"
                                    @report="report(item)"
                                    @edit="edit(item)"
                                    @deleteFun="deleteFun(item)"
                                  ></detailCardVue>
                                  
                                </div>
                              </div>
                              <div
                                v-if="item.sgL_Type === 'Image'"
                                class="feedpost card_group"
                              >
                                <div class="group_card-body">
                                  <div class="group_feedpost-content">
                                    <p class="message_txt">
                                      {{ item.sgL_Content }}
                                    </p>
                                    <div class="group_mulit-photo">
                                      <img
                                        class="mu_photo"
                                        :src="ig"
                                        v-for="(
                                          ig, ix
                                        ) in item.sgL_GroupImageTemplS"
                                        @click="showImg(item, ix)"
                                      />
                                    </div>
                                  </div>
                                  <detailCardVue
                                    :item="item"
                                    :sgL_UsersId="dataInfo.sgL_UsersId"
                                    @addfavorite="addfavorite"
                                    @commentShow="commentShow(item)"
                                    @share="share(item)"
                                    @report="report(item)"
                                    @edit="edit(item)"
                                    @deleteFun="deleteFun(item)"
                                  ></detailCardVue>

                                </div>
                              </div>
                              <div
                                v-if="item.sgL_Type === 'Photo'"
                                class="feedpost card_group"
                              >
                                <div class="group_card-body">
                                  <div class="group_feedpost-content">
                                    <p class="message_txt">
                                      {{ item.sgL_Content }}
                                    </p>
                                    <router-link
                                      target="_blank"
                                      :to="{
                                        name: 'albumviewPhotostream',
                                        query: { id: item.sgL_ImageTempId },
                                      }"
                                    >
                                      <div class="group_mulit-photo">
                                        <img
                                          v-if="item.sgL_GroupImageTemplS"
                                          class="photo_book"
                                          :src="item.sgL_GroupImageTemplS[0]"
                                        />
                                        <p class="desc_txt"> {{ $t('Social.group.groupDetail.PhotoAlbumSharing') }}</p>
                                        <p class="desc_txt" v-if="!item.sgL_IsShow" > {{ $t('Social.group.groupDetail.hidden') }}</p>
                                      </div>
                                    </router-link>
                                  </div>
                                  <detailCardVue
                                    :item="item"
                                    :sgL_UsersId="dataInfo.sgL_UsersId"
                                    @addfavorite="addfavorite"
                                    @commentShow="commentShow(item)"
                                    @share="share(item)"
                                    @report="report(item)"
                                    @edit="edit(item)"
                                    @deleteFun="deleteFun(item)"
                                  ></detailCardVue>

                                </div>
                              </div>
                              <div
                                v-if="item.sgL_Type === 'Moive'"
                                class="feedpost card_group"
                              >
                                <div class="group_card-body">
                                  <div class="group_feedpost-content">
                                    <p class="message_txt">
                                        {{ item.sgL_Content }}
                                      </p>
                                    <!-- ShortVideo Post -->
                                    <div class="group_mulit-photo">
                                      <div class="video">
                                        <!-- <video
                                          class="cloud-video-steam video-player vjs-custom-skin"
                                          controls=""
                                          preload="metadata"
                                          :poster="item.sgL_ImageTempURL"
                                        >
                                          <source
                                            :src="
                                              item.sgL_IsShare
                                                ? item.fileShareUrl
                                                : item.fileUrl
                                            "
                                          /> -->
                                          <!-- <source
                                            src="//video.shipin520.com/videos/29/88/18/b_wJrPbxkz4i1E1592298818.mp4"
                                          /> -->
                                        <!-- </video> -->

                                              <video-player 
         
          class="video-player vjs-custom-skin"
          :playsinline="true"
          :options="playerOptions[item.id]"
          @play="onPlayerPlay($event, item.id)"
        ></video-player>

                                        <p class="desc_txt"> {{ $t('Social.group.groupDetail.ShortVideoSharing') }}</p>
                                        <p class="desc_txt" v-if="!item.sgL_IsShow" > {{ $t('Social.group.groupDetail.hidden') }}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <detailCardVue
                                    :item="item"
                                    :sgL_UsersId="dataInfo.sgL_UsersId"
                                    @addfavorite="addfavorite"
                                    @commentShow="commentShow(item)"
                                    @share="share(item)"
                                    @report="report(item)"
                                    @edit="edit(item)"
                                    @deleteFun="deleteFun(item)"
                                  ></detailCardVue>
                                </div>
                              </div>
                              <div v-for="msg in item.sgL_MessageAll">
                                <div class="group_card-body_reply pl-5 pb-2">
                                  <div class="group_feedpost-content">
                                    <p class="group_reply_txt message_txt">
                                      <b class="group_reply_user"
                                        >{{ item.sgL_UsersName }} :</b
                                      >{{ item.sgL_Content }}
                                    </p>
                                    <p class="message_txt">
                                      {{ msg.sgL_Msg_MContent }}
                                    </p>
                                  </div>
                                  <ul
                                    class="group_feedpost-action"
                                    style="height: 40px"
                                    v-if="msg.sgL_Mem_Cid !== item.sgL_UserID"
                                  >
                                    <div class="group_feedpost-user">
                                      <img
                                        class="user-logo mr-2"
                                        :src="msg.sgL_ImageLogin"
                                      />
                                      
                                          <!-- {{ msg.sgL_Mem_DisplayName }} -->
                                          <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': msg.sgL_Mem_Cid } }">
                                            <span class="group_feedpost-username">
                                              {{ msg.sgL_Mem_DisplayName }}
                                            </span>
                                          </router-link>
                                      <span class="publish-time">{{
                                        msg.sgL_Msg_MAddTimerI
                                      }}</span>
                                    </div>
                                    <div>
                                      <!-- reply comment icon -->
                                      <div
                                        class="group_feedpost-more"
                                        v-if="
                                          canModifyComment(msg.sgL_Mem_Cid) ||
                                          isCanDel(msg.sgL_Mem_Cid)
                                        "
                                      >
                                        <i class="fa fa-ellipsis-h"></i>
                                        <div class="group_reply-menus">
                                          <a
                                            href="javascript:;"
                                            @click="editMessage(msg)"
                                            v-if="
                                              canModifyComment(msg.sgL_Mem_Cid)
                                            "
                                          >
                                            <li class="mondify">
                                              <i class="fas fa-edit"></i>
                                               {{ $t('Social.group.groupDetail.Editing') }}
                                            </li>
                                          </a>
                                          <a
                                            href="javascript:;"
                                            @click="delComment(msg.id, item)"
                                            v-if="isCanDel(msg.sgL_Mem_Cid)"
                                          >
                                            <li class="delete">
                                              <i
                                                class="far fa-trash-alt mr-1"
                                              ></i>
                                               {{ $t('Social.group.groupDetail.delpost') }}
                                            </li>
                                          </a>
                                        </div>
                                      </div>
                                      <li class="like">
                                        <i
                                          class="fa-thumbs-up mr-1"
                                          :class="{
                                            fas: msg.sgL_IsLike,
                                            far: !msg.sgL_IsLike,
                                          }"
                                          @click="likeMessage(msg)"
                                        ></i>
                                        <span v-if="msg.sgL_Msg_MQuantity">
                                          {{ msg.sgL_Msg_MQuantity }}
                                        </span>
                                      </li>
                                      <li
                                        class="comment"
                                        data-toggle="modal"
                                        data-target="#replycomment"
                                        @click="commentShow2(msg, item)"
                                      >
                                        <i class="far fa-comment mr-1"></i>
                                      </li>
                                    </div>
                                  </ul>
                                  <ul
                                    v-else
                                    class="group_self_feedpost-action"
                                    style="height: 40px"
                                  >
                                    <div class="group_self_feedpost-user">
                                      <img
                                        class="user-logo mr-2"
                                        :src="msg.sgL_ImageLogin"
                                      />
                                      <!-- <span
                                        class="group_self_feedpost-username"
                                      >
                                        {{ msg.sgL_Mem_DisplayName }}</span
                                      > -->
                                      <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': msg.sgL_Mem_Cid } }">
                                            <span class="group_self_feedpost-username">
                                              {{ msg.sgL_Mem_DisplayName }}
                                            </span>
                                          </router-link>
                                      <span class="publish-time">{{
                                        msg.sgL_Msg_MAddTimerI
                                      }}</span>
                                    </div>
                                    <div style="float: right">
                                      <li class="like">
                                        <i
                                          class="fa-thumbs-up mr-1"
                                          :class="{
                                            fas: msg.sgL_IsLike,
                                            far: !msg.sgL_IsLike,
                                          }"
                                          @click="likeMessage(msg)"
                                        ></i>
                                        <span v-if="msg.sgL_Msg_MQuantity">
                                          {{ msg.sgL_Msg_MQuantity }}
                                        </span>
                                      </li>
                                      <li
                                        class="comment"
                                        data-toggle="modal"
                                        data-target="#replycomment"
                                        @click="commentShow2(msg, item)"
                                      >
                                        <i class="far fa-comment mr-1"></i>
                                      </li>
                                      <div
                                        class="group_self_feedpost-more"
                                        v-if="
                                          canModifyComment(msg.sgL_Mem_Cid) ||
                                          isCanDel(msg.sgL_Mem_Cid)
                                        "
                                      >
                                        <i class="fa fa-ellipsis-h"></i>
                                        <div class="group_self_feedpost-menus">
                                          <a
                                            href="javascript:;"
                                            @click="editMessage(msg)"
                                            v-if="
                                              canModifyComment(msg.sgL_Mem_Cid)
                                            "
                                          >
                                            <li class="mondify">
                                              <i class="fas fa-edit"></i>
                                               {{ $t('Social.group.groupDetail.Editing') }}
                                            </li>
                                          </a>
                                          <a
                                            href="javascript:;"
                                            @click="delComment(msg.id, item)"
                                            v-if="isCanDel(msg.sgL_Mem_Cid)"
                                          >
                                            <li class="delete">
                                              <i
                                                class="far fa-trash-alt mr-1"
                                              ></i>
                                               {{ $t('Social.group.groupDetail.delpost') }}
                                            </li>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </ul>
                                </div>
                                <div
                                  v-for="msg2 in msg.messageDto"
                                  class="group_card-body_reply pl-5 pb-2"
                                >
                                  <div class="group_feedpost-content">
                                    <p class="group_reply_txt message_txt">
                                      <b class="group_reply_user"
                                        >{{ getTitle(msg2, msg)[0] }} :</b
                                      >{{ getTitle(msg2, msg)[1] }}
                                    </p>
                                    <p class="message_txt">
                                      {{ msg2.sgL_Msg_MContent }}
                                    </p>
                                  </div>
                                  <ul
                                    class="group_feedpost-action"
                                    style="height: 40px"
                                    v-if="msg2.sgL_Mem_Cid !== item.sgL_UserID"
                                  >
                                    <div class="group_feedpost-user">
                                      <img
                                        class="user-logo mr-2"
                                        :src="msg2.sgL_ImageLogin"
                                      />
                                      <span class="group_feedpost-username">
                                        <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': msg2.sgL_Mem_Cid } }">
                                              {{ msg2.sgL_Mem_DisplayName }}
                                          </router-link>
                                        </span>
                                      <span class="publish-time">{{
                                        msg2.sgL_Msg_MAddTimerI
                                      }}</span>
                                    </div>
                                    <div>
                                      <!-- function icon -->
                                      <div
                                        class="group_feedpost-more"
                                        v-if="
                                          canModifyComment(msg2.sgL_Mem_Cid) ||
                                          isCanDel(msg2.sgL_Mem_Cid)
                                        "
                                      >
                                        <i class="fa fa-ellipsis-h"></i>
                                        <div class="group_reply-menus">
                                          <a
                                            href="javascript:;"
                                            @click="editMessage(msg2)"
                                            v-if="
                                              canModifyComment(msg2.sgL_Mem_Cid)
                                            "
                                          >
                                            <li class="mondify">
                                              <i class="fas fa-edit"></i>
                                               {{ $t('Social.group.groupDetail.Editing') }}
                                            </li>
                                          </a>
                                          <a
                                            href="javascript:;"
                                            @click="delComment(msg2.id, item)"
                                            v-if="isCanDel(msg2.sgL_Mem_Cid)"
                                          >
                                            <li class="delete">
                                              <i
                                                class="far fa-trash-alt mr-1"
                                              ></i>
                                               {{ $t('Social.group.groupDetail.delpost') }}
                                            </li>
                                          </a>
                                        </div>
                                      </div>
                                      <li class="like">
                                        <i
                                          class="fa-thumbs-up mr-1"
                                          :class="{
                                            fas: msg2.sgL_IsLike,
                                            far: !msg2.sgL_IsLike,
                                          }"
                                          @click="likeMessage(msg2)"
                                        ></i
                                        ><span v-if="msg2.sgL_Msg_MQuantity">
                                          {{ msg2.sgL_Msg_MQuantity }}
                                        </span>
                                      </li>
                                      <li
                                        class="comment"
                                        data-toggle="modal"
                                        data-target="#replycomment"
                                        @click="commentShow2(msg2, item)"
                                      >
                                        <i class="far fa-comment mr-1"></i>
                                      </li>
                                      <!-- reply comment icon -->
                                    </div>
                                  </ul>
                                  <ul
                                    class="group_self_feedpost-action"
                                    style="height: 40px"
                                    v-else
                                  >
                                    <div class="group_self_feedpost-user">
                                      <img
                                        class="user-logo mr-2"
                                        :src="msg2.sgL_ImageLogin"
                                      />
                                      <span class="group_feedpost-username">

                                        <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': msg2.sgL_Mem_Cid } }">
                                              {{ msg2.sgL_Mem_DisplayName }}
                                          </router-link>  
                                      </span>
                                      <span class="publish-time">{{
                                        msg2.sgL_Msg_MAddTimerI
                                      }}</span>
                                    </div>
                                    <div style="float: right">
                                      <!-- function icon -->
                                      <li class="like">
                                        <i
                                          class="fa-thumbs-up mr-1"
                                          :class="{
                                            fas: msg2.sgL_IsLike,
                                            far: !msg2.sgL_IsLike,
                                          }"
                                          @click="likeMessage(msg2)"
                                        ></i
                                        ><span v-if="msg2.sgL_Msg_MQuantity">
                                          {{ msg2.sgL_Msg_MQuantity }}
                                        </span>
                                      </li>
                                      <li
                                        class="comment"
                                        data-toggle="modal"
                                        data-target="#replycomment"
                                        @click="commentShow2(msg2, item)"
                                      >
                                        <i class="far fa-comment mr-1"></i>
                                      </li>
                                      <div
                                        class="group_self_feedpost-more"
                                        v-if="
                                          canModifyComment(msg2.sgL_Mem_Cid) ||
                                          isCanDel(msg2.sgL_Mem_Cid)
                                        "
                                      >
                                        <i class="fa fa-ellipsis-h"></i>
                                        <div class="group_self_feedpost-menus">
                                          <a
                                            href="javascript:;"
                                            @click="editMessage(msg2)"
                                            v-if="
                                              canModifyComment(msg2.sgL_Mem_Cid)
                                            "
                                          >
                                            <li class="mondify">
                                              <i class="fas fa-edit"></i>
                                               {{ $t('Social.group.groupDetail.Editing') }}
                                            </li>
                                          </a>
                                          <a
                                            href="javascript:;"
                                            @click="delComment(msg2.id, item)"
                                            v-if="isCanDel(msg2.sgL_Mem_Cid)"
                                          >
                                            <li class="delete">
                                              <i
                                                class="far fa-trash-alt mr-1"
                                              ></i>
                                               {{ $t('Social.group.groupDetail.delpost') }}
                                            </li>
                                          </a>
                                        </div>
                                      </div>
                                      <!-- reply comment icon -->
                                    </div>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div
                              id="group_card_disp_btn"
                              @click="showMore"
                              v-if="isShowMore"
                            >
                              <hr class="group_card_hrline" />
                               {{ $t('Social.group.groupDetail.ShowMore') }}
                              <hr class="group_card_hrline" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 右側群組內容結束 -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <button
              type="button"
              class="btn btn-block btn-primary btn-fixed"
              data-hover="Click me!"
              data-toggle="modal"
              @click="add"
            >
              <i class="fa fa-plus fa-fw fa-sm mr-1" aria-hidden="true"></i
              ><i></i>
               {{ $t('Social.group.groupDetail.AddPost') }}
            </button>
          </div>
        </div>
      </div>
    </section>
    <div
      id="groupfriendlist"
      class="modal fade show"
      style="padding-right: 5px"
      aria-modal="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-content-title"> {{ $t('Social.group.groupDetail.FriendsInGroup') }}</div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="feedpost-user friendlist_fm">
              <div
                class="friendlist_user"
                v-for="(item, ix) in friends"
                :key="ix"
                @click="goFriend(item)"
              >
                <img
                  class="user-logo"
                  :src="item.toUsersLogoBig"
                  alt="user-icon"
                />
                <span class="txt">{{ item.sgL_ToUsersName }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div
      id="create-grouppost"
      class="modal fade show"
      style="padding-right: 5px"
      aria-modal="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-content-title">{{ editTitle }}</div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="feedpost-user">
              <div class="">
                <img class="user-logo" :src="getimage" alt="user-icon" />
              </div>
              <div class="right" v-if="type != 3">
                 {{ $t('Social.group.groupDetail.hiddenpost') }}
                <el-switch
                  v-model="form.sgL_IsShow"
                  active-value="0"
                  inactive-value="1"
                >
                </el-switch>
              </div>
              <p v-if="type != 3" class="desc_txt">
               {{ $t('Social.group.groupDetail.Afterhiding') }}
              </p>
            </div>
            <textarea
              class="form-control"
              type="text"
              rows="2"
              cols="50"
              :placeholder="$t('Social.group.groupDetail.placeholderText')"
              v-if="type != 3"
              v-model="form.sgL_Content"
            ></textarea>

            <!-- .END 分享影片框 -->
            <div id="uploadphoto" v-if="type === 1">
              <div class="uploadfile_fm">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="
                    form.sgL_Image = '';
                    form.sgL_ImageTempId = 0;
                    type = 0;
                    form.sgL_Type = 'Content';
                  "
                >
                  <span aria-hidden="true">×</span>
                </button>

                <div class="upload__box">
                  <el-upload
                    ref="upload"
                    :auto-upload="true"
                    class="upload-demo"
                    :before-upload="imgSaveToUrl"
                    :on-success="imgSuccess"
                    :on-error="imgError"
                    :action="uploadUrlImg"
                    :headers="header"
                    :limit="1"
                    :show-file-list="false"
                  >
                    <div class="upload__btn-box">
                      <label class="upload__btn">
                        <p>{{ $t('Social.group.groupDetail.fileupload') }}</p>
                      </label>
                    </div>
                  </el-upload>
                  <div class="upload__img-wrap">
                    <div
                      class="upload__img-box"
                      v-for="item in imgList"
                      :key="item.url"
                    >
                      <div
                        :style="{ 'background-image': `url(${item.url})` }"
                        class="img-bg"
                      >
                        <div
                          class="upload__img-close"
                          @click="delImg(item)"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="sharephoto" v-if="type === 2">
              <!-- 分享相簿照片框 -->
              <div class="sharelink_fm">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="
                    form.sgL_ShareImage = '';
                    type = 0;
                    form.sgL_Type = 'Content';
                  "
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div>
                  <input
                    class="input_box"
                    type="text"
                    v-model="form.sgL_ShareImage"
                    :placeholder="$t('Social.group.groupDetail.shortlink')"
                  />
                </div>
              </div>
            </div>
            <div id="social_video" class="mb-4" v-if="type === 3">
              <!-- 分享影音牆,短視影片框 -->
              <div class="sharelink_fm">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="
                    type = 0;
                    form.sgL_Type = 'Content';
                  "
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div id="app2">
                  <div id="app1" class="video-uploader">
                    <div>
                      <el-upload
                        class="upload-demo"
                        ref="upload2"
                        :auto-upload="false"
                        drag
                        :limit="1"
                        :show-file-list="false"
                        :on-change="videoSaveToUrl"
                        :action="uploadUrl"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          {{ $t('Social.group.groupDetail.upload') }}<em>{{ $t('Social.group.groupDetail.clickupload') }}</em>
                        </div>
                        <div
                          class="el-upload__tip"
                          slot="tip"
                          style="text-align: center"
                        >
                          <ul>
                            <li>
                              <el-progress
                                :text-inside="true"
                                :stroke-width="24"
                                :percentage="progress"
                                status="success"
                              ></el-progress>
                            </li>
                            <li v-show="fileName != ''">
                              {{ $t('Social.group.groupDetail.checkupload') }}<span
                                style="font-size: 24px; color: #26ad5e"
                                >{{ fileName }}</span
                              >
                            </li>
                            <li>{{ $t('Social.group.groupDetail.type') }}</li>
                            <li>
                              {{ $t('Social.group.groupDetail.msg') }}
                            </li>
                          </ul>
                        </div>
                      </el-upload>
                      <ul class="el-upload-list el-upload-list--text"></ul>
                    </div>
                    <div id="app2">
                      <div class="col-12">
                        <div class="card card-primary">
                          <div class="card-body">
                            <div class="row">
                              <div
                                class="section-group col-md-12 col-lg-4 pr-lg-4"
                              >
                                <label for="video-image"
                                  >{{ $t('Social.group.groupDetail.msg2') }}</label
                                >
                                <div class="video-thumbnail w-100">
                                  <div class="video-responsive mb-2">
                                    <div class="video-sizer"></div>
                                    <div class="video-content">
                                      <div
                                        class="layout h-100 align-center ma-0"
                                      >
                                        <div class="layout-flex">
                                          <div class="text-center o-60">
                                            <i
                                              v-if="!form.sgL_Image"
                                              class="fas fa-film fa-2x"
                                            ></i>
                                            <img
                                              v-else
                                              :src="form.sgL_Image"
                                              class="pr-vi-img"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <el-upload
                                  class="upload-demo"
                                  action=""
                                  :limit="1"
                                  :auto-upload="false"
                                  :on-change="changeUpload"
                                  :show-file-list="false"
                                  ref="fmtUpload"
                                >
                                  <button
                                    type="button"
                                    class="
                                      btn btn-block btn-default btn-sm
                                      mb-3
                                    "
                                    style="margin-left: 0px"
                                  >
                                    <i class="nav-icon fas fa-image mr-1"></i>
                                    {{ $t('Social.group.groupDetail.image') }}
                                  </button>
                                </el-upload>
                                <dl class="row">
                                  <dt class="col-12">{{ $t('Social.group.groupDetail.File_name') }}:</dt>
                                  <dd class="col-12">{{ fileName }}</dd>
                                  <dt class="col-12">{{ $t('Social.group.groupDetail.widhei') }}:</dt>
                                  <dd class="col-12">
                                    {{ form.sgL_Width }}x{{ form.sgL_Height }}
                                  </dd>
                                  <dt class="col-12">{{ $t('Social.group.groupDetail.sgL_Size') }}:</dt>
                                  <dd class="col-12">
                                    {{
                                      (form.sgL_Size / 1024 / 1024).toFixed(2)
                                    }}M
                                  </dd>
                                  <dt class="col-12">{{ $t('Social.group.groupDetail.displayName') }}:</dt>
                                  <dd class="col-12">
                                    {{ loginUser.displayName }}
                                  </dd>
                                  <dt class="col-12">{{ $t('Social.group.groupDetail.videoCreateTime') }}:</dt>
                                  <dd class="col-12">{{ videoCreateTime }}</dd>
                                </dl>
                              </div>
                              <div class="section-group col-md-12 col-lg-8">
                                <label for="video-name" class="mt-3"
                                  >*{{ $t('Social.group.groupDetail.videoTitle') }}</label
                                >
                                <div class="el-input">
                                  <el-input
                                    type="text"
                                    :placeholder="$t('Social.group.groupDetail.placeholderTitle')"
                                    v-model="form.sgL_Title"
                                    maxlength="28"
                                    show-word-limit
                                  >
                                  </el-input>
                                </div>
                                <label for="video-description" class="mt-3"
                                  >{{ $t('Social.group.groupDetail.VideoDescription') }}</label
                                >
                                <div class="el-textarea">
                                  <el-input
                                    v-model="form.sgL_Content"
                                    placeholder=""
                                    type="textarea"
                                    maxlength="124"
                                    show-word-limit
                                  >
                                  </el-input>
                                </div>
                                <label for="video-keywords" class="mt-3"
                                  >{{ $t('Social.group.groupDetail.keys') }}</label
                                >
                                <div class="el-input">
                                  <el-input
                                    type="text"
                                    :placeholder="$t('Social.group.groupDetail.eg')"
                                    v-model="form.sgL_Keyworld"
                                    show-word-limit
                                  >
                                  </el-input>
                                </div>
                                <label for="video-status" class="mt-3"
                                  > {{ $t('Social.group.groupDetail.PrivacySettings') }}</label
                                >
                                <el-select
                                  v-model="form.sgL_IsShow"
                                  :placeholder="$t('Social.group.groupDetail.pleasechoose')"
                                >
                                  <el-option :label="$t('Social.group.groupDetail.open')" value="2">
                                  </el-option>
                                  <el-option
                                    :label="$t('Social.group.groupDetail.msg3')"
                                    value="1"
                                  >
                                  </el-option>
                                  <el-option
                                    :label="$t('Social.group.groupDetail.NULLOPEN')"
                                    value="0"
                                  >
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sel_funtion_bar" v-if="this.editTitle !== '編輯帖文'">
              <div class="sel_icon">
                <a
                  href="javascript:;"
                  @click="
                    type = 1;
                    form.sgL_Type = 'Image';
                  "
                  ><i class="fas fa-file-image uploadphotocolor"></i
                ></a>
                <a
                  href="javascript:;"
                  @click="
                    type = 2;
                    form.sgL_Type = 'Photo';
                  "
                  ><i class="fas fa-images sharephotocolor"></i
                ></a>
                <a href="javascript:;" @click="pushVideo"
                  ><i class="fas fa-video sharevideocolor"></i
                ></a>
              </div>
              <span class="txt">" {{ $t('Social.group.groupDetail.NewPost') }}"</span>
            </div>
          </div>
          <div class="modal-footer justify-content-end">
            <div class="btn btn-primary" @click="push"> {{ $t('Social.group.groupDetail.Release') }}</div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <ImgCropperVue
      class="ImgCropperVue"
      ref="cro"
      @cropperConfirm="cropperConfirm"
      @cropperCancel="cropperCancel"
      :props_autoCropWidth="1280"
      :props_autoCropHeight="720"
      :props_full="false"
      :props_original="true"
      :props_centerBox="true"
      :props_high="true"
      :props_fixed="true"
      :props_info="true"
      :props_canMove="true"
      :props_fixedNumber="[1.7777, 1]"
    >
    </ImgCropperVue>
    <ReportVue ref="report" :props_title="$t('Social.group.groupDetail.ReportVueTitle')"></ReportVue>
    <div
      id="replycomment"
      class="modal fade show"
      style="padding-right: 5px"
      aria-modal="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p class="group_reply_fm">
              <!-- reply input box -->
              <el-input
                type="textarea"
                :rows="4"
                :placeholder="$t('Social.group.groupDetail.response')"
                v-model="commentObj.text"
              >
              </el-input>
            </p>
            <p style="display: flex; justify-content: center">
              <input
                class="btn bg-black"
                style="margin: 0 5px; width: 60px"
                data-dismiss="modal"
                aria-label="Close"
                type="submit"
                :value="$t('Social.group.groupDetail.Close')"
              />
              <input
                class="btn bg-black"
                style="margin: 0 5px; width: 60px"
                data-dismiss="modal"
                @click="sendComment"
                :value="$t('Social.group.groupDetail.OK')"
              />
            </p>
            <p></p>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div
      id="replycomment2"
      class="modal fade show"
      style="padding-right: 5px"
      aria-modal="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p class="group_reply_fm">
              <!-- reply input box -->
              <el-input
                type="textarea"
                :rows="4"
                :placeholder="$t('Social.group.groupDetail.SocialPublish')"
                v-model="commentObj2.text"
              >
              </el-input>
            </p>
            <p style="display: flex; justify-content: center">
              <input
                class="btn bg-black"
                style="margin: 0 5px; width: 60px"
                data-dismiss="modal"
                aria-label="Close"
                type="submit"
                :value="$t('Social.group.groupDetail.Close')"
              />
              <input
                class="btn bg-black"
                style="margin: 0 5px; width: 60px"
                data-dismiss="modal"
                @click="sendComment2"
                :value="$t('Social.group.groupDetail.OK')"
              />
            </p>
            <p></p>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <groupImgVue ref="groupImgVue" />
  </div>
</template>

<script>
import UserFeedInfoVue from "@/components/Social/UserFeedInfo.vue";
import ImgCropperVue from "@/components/common/ImgCropper.vue";
import base from "@/api/httpApi/base";
import fileupload from "@/assets/backJs/util2";
import { Message } from "element-ui";
import ReportVue from "@/components/common/Report.vue";
import detailCardVue from "@/components/Social/group/detailCard.vue";
import groupImgVue from "@/components/Social/group/groupImg.vue";
import socialTool from "../../../assets/js/socialJs/tool";
export default {
  components: {
    UserFeedInfoVue,
    ImgCropperVue,
    ReportVue,
    detailCardVue,
    groupImgVue,
  },
  data() {
    return {
      playerOptions: {},
      noChangeVideoList: [],
      editTitle: "新增帖文",
      isShowMore: true,
      pageInfo: {
        page: 1,
        size: 10,
      },
      commentObj: {
        text: "",
        item: {},
      },
      commentObj2: {
        text: "",
        item: {},
      },
      uploadUrl: "",
      uploadUrlGuid: "",
      sgL_GroupImageTempl: "",
      date: "",
      AllsgL_GroupContent: false,
      dataInfo: {},
      pageData: [],
      backColor: "",
      backImg: "",
      fontColor: "",
      friends: [],
      type: 0,
      imgList: [],
      header: {
        Authorization: "Bearer " + this.$store.state.permission.token,
      }, // 有的图片服务器要求请求头需要有token
      form: {
        sgL_Content: "",
        sgL_ImageTempId: 0,
        sgL_Image: "",
        sgL_MoiveTempId: 0,
        sgL_Moive: "",
        sgL_IsShow: "1",
        sgL_GroupId: this.$route.query.sgL_GroupId,
        sgL_ShareImage: "",
        sgL_Title: "",
        sgL_Keyworld: "",
        sgL_Width: 0,
        sgL_Height: 0,
        sgL_Size: 0,
        sgL_Length: "",
        sgL_Type: "Content",
      },
      fileName: "",
      uploadVideo: "",
      progress: 0,
      videoCreateTime: "",
    };
  },
  created() {
    if (this.loginUser) {
      this.uploadUrl = `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=moiveCommunity&id=${this.loginUser.userId}`;
    }
    this.getData();
  },
  computed: {
    uploadUrlImg() {
      return `${base.dev}/TokenAuth/UploadTempPhotoShar?temp=${this.uploadUrlGuid}`;
    },
    getimage() {
      if (this.$store.getters.getcustomer != null) {
        return (
          this.$store.getters.getcustomer.userLogoSmail + "?v=" + this.getN()
        );
      } else {
        return "https://api.soonnet.org/Userlogo_Smail.jpg";
      }
    },
  },
  methods: {
    onPlayerPlay (player, index) {
      if (this.currentPlayer && this.currentPlayer != player) {
        this.currentPlayer.pause();
      }
      this.currentPlayer = player;
    },
    goFriend(item) {
      // console.log(item);
      let routeData = this.$router.resolve({
        name: "customerPublishLook",
        query: {
          authorId: item.sgL_ToUsersId,
        },
      });
      window.open(routeData.href, "_blank");
    },
    getTitle(msg, dto) {
      const info = dto.messageDto.find((c) => c.id === msg.sgL_Msg_ReplyMsgid);
      if (info) {
        return [`${info.sgL_Mem_DisplayName}`, `${info.sgL_Msg_MContent}`];
      } else {
        if (dto.id === msg.sgL_Msg_ReplyMsgid) {
          return [`${dto.sgL_Mem_DisplayName}`, `${dto.sgL_Msg_MContent}`];
        }
      }
      return ["", ""];
    },
    editMessage(msg) {
      this.commentObj2.text = msg.sgL_Msg_MContent;
      this.commentObj2.item = msg;
      $("#replycomment2").modal("show");
    },
    likeMessage(msg) {
      this.$api.social
        .AddMessageLike({
          msgId: msg.id,
          // groupId: this.$route.query.sgL_GroupId
        })
        .then((res) => {
          msg.sgL_IsLike = !msg.sgL_IsLike;
          if (msg.sgL_IsLike) {
            msg.sgL_Msg_MQuantity = msg.sgL_Msg_MQuantity + 1;
          } else {
            msg.sgL_Msg_MQuantity = msg.sgL_Msg_MQuantity - 1;
          }
        });
    },
    showImg(item, ix) {
      this.$refs.groupImgVue.setData(item.sgL_GroupImageTemplP, ix);
      this.$refs.groupImgVue.showWindow();
    },
    pushVideo() {
      //判断是否已认证
      if (!this.loginUser.sgL_IsCheck) {
        $("#create-grouppost").modal("hide");
        //跳转到认证页面
        this.$router.push({
          name: "certification",
          query: {
            redirect: `/feedHome/feedGroupDetail?sgL_GroupId=${this.$route.query.sgL_GroupId}`,
          },
        });
        return;
      } else {
        this.type = 3;
        this.form.sgL_Type = "Moive";
        this.form.sgL_IsShow = "1";
      }
    },
    isCanDel(id) {
      if (
        this.loginUser.userId === this.dataInfo.sgL_UsersId ||
        id === this.loginUser.userId
      ) {
        return true;
      }
      return false;
    },
    canModifyComment(id) {
      if (id === this.loginUser.userId) {
        return true;
      }
      return false;
    },
    delComment(id, item) {
      let params = {
        Id: id,
      };
      this.$api.common.deleteMsg(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.$api.social
            .FindMoiveCommunityByGroupId({
              sgL_GroupId: this.$route.query.sgL_GroupId,
              SkipCount: 0,
              MaxResultCount: 10,
              sgL_MoiveCommunityId: item.id,
            })
            .then((res) => {
              if (res.data.success) {
                item.sgL_MessageAll =
                  res.data.result.communityOutput.items[0].sgL_MessageAll;
              }
            });
        }
      });
    },
    edit(item) {
      this.editTitle = "編輯帖文";
      this.$api.social
        .GetMoiveCommunityByGroupId({ id: item.id })
        .then((res) => {
          this.form = res.data.result;
          this.form.sgL_IsShow = res.data.result.sgL_IsShow + "";
          this.form.sgL_GroupId = this.$route.query.sgL_GroupId;
          if (res.data.result.sgL_Type === "Content") {
            this.type = 0;
          } else if (res.data.result.sgL_Type === "Image") {
            this.type = 1;
            this.uploadUrlGuid =
              res.data.result.sgL_GroupImageTempl.split("/")[
                res.data.result.sgL_GroupImageTempl.split("/").length - 1
              ];
            this.sgL_GroupImageTempl = res.data.result.sgL_GroupImageTempl;
            this.imgList = res.data.result.sgL_GroupImageTemplS.map((item) => {
              let url = item.replace(/\\/g, "/");
              return {
                url,
                uploadName: url.split("/")[url.split("/").length - 1],
                id: url.split("/")[url.split("/").length - 1],
              };
            });
          } else if (res.data.result.sgL_Type === "Photo") {
            this.type = 2;
            this.form.sgL_ShareImage = res.data.result.sgL_GroupImageTempl;
          } else if (res.data.result.sgL_Type === "Moive") {
            this.type = 3;
            this.form.sgL_Image = res.data.result.sgL_ImageTempURL;
            this.fileName = res.data.result.uploadTemplDto.sgL_FileName;
            this.videoCreateTime =
              res.data.result.uploadTemplDto.sgL_CreateTimeF;
          }
        });
      $("#create-grouppost").modal("show");
    },
    canModify(item) {
      if (
        item.sgL_UserID === this.dataInfo.sgL_UsersId ||
        item.sgL_UserID === this.loginUser.userId
      ) {
        return true;
      }
      return false;
    },
    showMore() {
      this.pageInfo.page++;
      this.getPageList();
    },
    sendComment() {
      this.$api.albumApi
        .createMessage({
          SGL_Mem_FinallyReceive_Cid:
            this.commentObj.item.SGL_Mem_FinallyReceive_Cid,
          sgL_Msg_MContent: this.commentObj.text,
          sgL_Msg_SendType: this.commentObj.item.sgL_Msg_SendType,
          sgL_Msg_Type: this.commentObj.item.sgL_Msg_Type,
          sgL_PG_CBigsort: this.commentObj.item.sgL_PG_CBigsort,
          sgL_PG_Coid: this.commentObj.item.sgL_PG_Coid,
          sgL_Msg_ReplyMsgid: this.commentObj.item.sgL_Msg_ReplyMsgid,
          sgL_Msg_Belongidc: this.commentObj.item.refItem.id,
        })
        .then((res) => {
          if (res.data.success) {
            this.$api.social
              .FindMoiveCommunityByGroupId({
                sgL_GroupId: this.$route.query.sgL_GroupId,
                SkipCount: 0,
                MaxResultCount: 10,
                sgL_MoiveCommunityId: this.commentObj.item.refItem.id,
              })
              .then((res) => {
                if (res.data.success) {
                  this.commentObj.item.refItem.sgL_MessageAll =
                    res.data.result.communityOutput.items[0].sgL_MessageAll;
                } else {
                  this.$message({
                    type: "error",
                    message: res.data.error.message,
                  });
                }
              });
          } else {
            this.$message({
              type: "error",
              message: res.data.error.message,
            });
          }
        });
    },
    sendComment2() {
      this.$api.social
        .MessageUpdate({
          sgL_Msg_MContent: this.commentObj2.text,
          id: this.commentObj2.item.id,
        })
        .then((res) => {
          if (res.data.success) {
            this.commentObj2.item.sgL_Msg_MContent = this.commentObj2.text;
          } else {
            this.$message({
              type: "error",
              message: res.data.error.message,
            });
          }
        });
    },
    commentShow(item) {
      let reqItem = {
        SGL_Mem_FinallyReceive_Cid: item.sgL_UserID,
        sgL_PG_Coid: this.$route.query.sgL_GroupId,
        sgL_Msg_Belongidc: item.id,
        sgL_Msg_SendType: 0,
        sgL_Msg_Type: 7,
        sgL_PG_CBigsort: 2,
        refItem: item,
      };
      this.commentObj.item = reqItem;
      this.commentObj.text = "";
      $("#replycomment").modal("show");
    },
    commentShow2(item, item2) {
      let reqItem = {
        SGL_Mem_FinallyReceive_Cid: item.sgL_Mem_Cid,
        sgL_PG_Coid: this.$route.query.sgL_GroupId,
        sgL_Msg_Belongidc: item.id,
        sgL_Msg_SendType: 1,
        sgL_Msg_Type: 7,
        sgL_PG_CBigsort: 2,
        sgL_Msg_ReplyMsgid: item.id,
        refItem: item2,
      };
      this.commentObj.item = reqItem;
      this.commentObj.text = "";
      $("#replycomment").modal("show");
    },
    report(item) {
      if (this.CheckUserIsLogin()) {
        this.$refs.report.init(
          this.$route.query.sgL_GroupId,
          item.sgL_UsersName,
          5,
          item.id
        );
      }
    },
    share(item) {
      let urlb = escape(`/Home/facebookResp?id=${item.id}&type=moivecommunity`);
      window.open(`${this.$shareUrl}${base.url}${urlb}`, "_blank");
    },
    addfavorite(tid, type, Ftype, longid, DevicesType, zd, item, zd2) {
      let params = {
        sgL_DevicesType: DevicesType,
        sgL_MasterSort: type, //类型
        sgL_PG_Coid: tid, //图册、影片、文章、活动的id
        sgL_Fav_FType: Ftype, //图册：0，图片：1，影片：2
        sgL_Fav_FBelongidc: longid, //图片id
      };
      this.$store.dispatch("addfavorite", params).then((res) => {
        if (res) {
          this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
          //this.getAlbumPhoto();
          if (zd) {
            item[zd] = !item[zd];
            if (zd2) {
              if (item[zd]) {
                item[zd2] = item[zd2] + 1;
              } else {
                item[zd2] = item[zd2] - 1;
              }
            }
          }
        }
      });
    },
    deleteFun(item) {
      this.$confirm("刪除後無法復原,確認刪除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: item.id,
          };
          this.$api.social.DeleteSocialData(params).then((res) => {
            if (res.data.success) {
              this.pageData = this.pageData.filter((c) => c.id !== item.id);
            } else {
              this.$message({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    delImg(item) {
      this.$api.social
        .UploadTempPhotoSharDel({
          //temp: this.uploadUrlGuid,
          temp: this.uploadUrlGuid,
          fileName: item.uploadName,
        })
        .then((res) => {
          this.imgList = this.imgList.filter((c) => c.id !== item.id);
        });
    },
    changeUpload(file, fileList) {
      this.$refs.fmtUpload.clearFiles();
      switch (file.raw.type) {
        case "image/jpeg":
          break;
        case "image/png":
          break;
        default:
          this.$message({
            message: "請選擇jpg/png格式",
          });
          return;
      }
      /* const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(`上傳文件大小不能超過 5MB!`);
        return false;
      } */
      let test = new Image();
      test.src = window.URL.createObjectURL(file.raw);
      let width = 0;
      let height = 0;
      let that = this;
      test.onload = function () {
        width = test.width;
        height = test.height;
        that.$refs.cro.initData(file);
        that.$refs.cro.setDialogVisible(true);
      };
    },
    cropperConfirm(img) {
      let formData = new FormData();
      formData.append("file", img, "DX.jpg");
      this.$api.albumApi
        .uploadImages(this.uploadUrl, formData)
        .then((res) => {
          if (res.data.success) {
            this.form.sgL_ImageTempId = res.data.result.uploadId;
            this.form.sgL_Image = res.data.result.url;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          console.log(err);
        });
      this.$refs.cro.setDialogVisible(false);
    },
    videoSaveToUrl(event) {
      if (
        [
          "video/mp4",
          "video/quicktime",
          "video/mpeg",
          "video/3gpp",
          "video/x-flv",
        ].indexOf(event.raw.type) == -1
      ) {
        Message({
          type: "warning",
          message: "請上傳正確的視頻格式",
        });
        this.$refs.upload2.clearFiles();
        return false;
      }
      this.getVideoMsg(event.raw)
        .then((res) => {
          this.form.sgL_Height = res.height;
          this.form.sgL_Width = res.width;
          this.form.sgL_Length = res.duration;
        })
        .then(() => {
          this.uploadVideo = event.raw;
          this.fileName = event.raw.name;
          this.progress = 0;
          this.videoImg = "";
          this.$refs.upload2.clearFiles();
          this.submitUpload();
        });
    },
    cropperCancel() {
      this.$refs.fmtUpload.clearFiles();
    },
    submitUpload() {
      this.progress = 0;
      this.form.sgL_Size = this.uploadVideo.size;
      fileupload.uploadFile(
        this.uploadVideo, //视频文件
        this.loginUser.accessToken, //权限token
        this.loginUser.userId,
        (uploadsuccess) => {
          //上传成功的函数
          this.uploadunite(uploadsuccess);
        },
        (successfile) => {
          this.$refs.upload2.clearFiles();
          this.form.sgL_MoiveTempId = successfile.result.uploadId; //给视频id赋值
          this.form.sgL_Moive = successfile.result.url;
          this.videoCreateTime = successfile.result.createTime;
          this.progress = 100;
          //this.ck1();
        },
        (process) => {
          //进度回调函数
          this.progress = process.toFixed(0) * 1;
        },
        (failePage) => {
          //分片上傳時如果服務斷掉會進入這裏
          Message({
            type: "error",
            message: failePage,
          });
          this.updateError = "，請檢查網絡！";
          this.$refs.upload2.clearFiles();
        }
      );
    },
    uploadunite(uploadsuccess) {
      uploadsuccess.sgL_Height = this.form.sgL_Height;
      uploadsuccess.sgL_Width = this.form.sgL_Width;
      //合并
      this.$api.VideoApi.uploadfileGather2(uploadsuccess)
        .then((res) => {
          if (res.data.success == false) {
            Message({
              type: "error",
              message: res.data.error.message,
            });
            this.$refs.upload2.clearFiles();
          } else {
            this.form.sgL_MoiveTempId = res.data.result.uploadId; //给视频id赋值
            this.form.sgL_Moive = res.data.result.url;
            this.videoCreateTime = res.data.result.createTime;
            //this.ck1();
          }
        })
        .catch((error) => {
          //請求失敗攔截
          if (this.num < 4) {
            setTimeout(() => {
              this.uploadunite(uploadsuccess);
              this.num++;
            }, 30000);
          }
        });
    },
    getVideoMsg(file) {
      return new Promise((resolve) => {
        let videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(file);
        videoElement.addEventListener("loadedmetadata", function () {
          resolve({
            duration: videoElement.duration,
            height: videoElement.videoHeight,
            width: videoElement.videoWidth,
          });
        });
      });
    },
    initForm() {
      this.form = {
        sgL_Content: "",
        sgL_ImageTempId: 0,
        sgL_Image: "",
        sgL_MoiveTempId: 0,
        sgL_Moive: "",
        sgL_IsShow: "1",
        sgL_GroupId: this.$route.query.sgL_GroupId,
        sgL_ShareImage: "",
        sgL_Title: "",
        sgL_Keyworld: "",
        sgL_Content: "",
        sgL_GroupImageTempl: "",
        sgL_Type: "Content",
      };
      this.imgList = [];
      this.type = 0;
      this.fileName = "";
      this.uploadVideo = "";
      this.progress = 0;
      this.videoCreateTime = "";
    },
    push() {
      let par = { ...this.form };
      if (this.type === 1) {
        par.sgL_GroupImageTempl = this.uploadUrlGuid;
      } else if (this.type === 3) {
        if (!par.sgL_MoiveTempId) {
          this.$message({ type: "error", message: "视频不能为空" });
          return;
        }
        if (!par.sgL_Title) {
          this.$message({ type: "error", message: "影片標題不能為空" });
          return;
        }
        if (!par.sgL_ImageTempId) {
          this.$message({ type: "error", message: "影片縮圖不能為空" });
          return;
        }
      }
      let meth = null;
      if (this.editTitle === "編輯帖文") {
        meth = this.$api.social.UpdateMoiveCommunity;
        par.sgL_GroupImageTempl = this.sgL_GroupImageTempl;
      } else {
        meth = this.$api.social.PushGroupCommunity;
      }
      meth(par).then((res) => {
        if (res.data.success) {
          $("#create-grouppost").modal("hide");
          this.initForm();
          this.getPageList(true);
          this.$message({ type: "success", message: "發布成功" });
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    imgSaveToUrl(file) {
      if (["image/jpeg", "image/png"].indexOf(file.type) == -1) {
        Message({
          type: "warning",
          message: "請選擇jpg/png格式",
        });
        return false;
      }
    },
    imgError(err, file, fileList) {},
    imgSuccess(response, file, fileList) {
      if (response.success) {
        this.$refs.upload.clearFiles();
        let test = new Image();
        test.src = window.URL.createObjectURL(file.raw);
        let _this = this;
        test.onload = function () {};
        this.imgList.push({
          url: response.result.url,
          uploadName: response.result.uploadName,
          id: this.uploadUrlGuid,
        });
      } else {
        this.$message({
          type: "error",
          message: response.error.message,
        });
      }
    },
    add() {
      this.editTitle = "新增帖文";
      this.initForm();
      this.uploadUrlGuid = this.getN();
      $("#create-grouppost").modal("show");
    },
    async showfriend() {
      if (this.loginUser.userId === this.dataInfo.sgL_UsersId) {
        this.$router.push({
          name: "feedGroup_groupAccList",
        });
        return;
      } else {
        this.friends = [];
        await this.MutualFriends();
        $("#groupfriendlist").modal("show");
      }
    },
    async MutualFriends() {
      const res = await this.$api.social.MutualFriends({
        groupId: this.$route.query.sgL_GroupId,
        skipCount: 0,
        maxResultCount: 999,
      });
      this.friends = res.data.result.items;
    },
    getData() {
      const id = this.$route.query.sgL_GroupId;
      this.$api.social
        .GroupGet({
          Id: id,
        })
        .then((res) => {
          this.dataInfo = res.data.result;
          this.backColor = res.data.result.sgL_BackgroundAndWord.split(",")[0];
          this.fontColor = res.data.result.sgL_BackgroundAndWord.split(",")[1];
          if (res.data.result.sgL_BackImage) {
            this.backImg = res.data.result.sgL_BackImage;
          }
          /* if (!this.backImg) {
            this.backImg =
              "http://218.255.155.125:47097/Account/Acc_Resources/1/Userlogo_Big.jpg";
          } */
          if (this.backColor === "null") {
            this.backColor = "initial";
          } else {
            this.backImg = "";
          }
          if (!this.fontColor) {
            this.fontColor = "initial";
          }
        });
      this.getPageList();
    },
    getPageList(isFirst) {
      if (isFirst) {
        this.pageInfo.page = 1;
        this.isShowMore = true;
      }
      const id = this.$route.query.sgL_GroupId;
      this.$api.social
        .FindMoiveCommunityByGroupId({
          sgL_GroupId: id,
          sgL_CreateTime: this.date,
          SkipCount: (this.pageInfo.page - 1) * this.pageInfo.size,
          MaxResultCount: this.pageInfo.size,
          sgL_MoiveCommunityId: this.$route.query.id,
        })
        .then((res) => {
          if (isFirst) {
            this.pageData = res.data.result.communityOutput.items;
              socialTool.setPlayerOptions(
              this.playerOptions,
              this.noChangeVideoList,
              res.data.result.communityOutput.items,
              1
            );
          } else {
            if (res.data.result.communityOutput.items.length === 0) {
              this.isShowMore = false;
            } else {
              this.pageData = [
                ...this.pageData,
                ...res.data.result.communityOutput.items,
              ];
              res.data.result.communityOutput.items.map((item,index)=>{
                socialTool.setPlayer(
                  this.playerOptions,
                  this.noChangeVideoList,
                  item.id,
                  item.fileUrl,
                  false,
                  this.IsNullOrEmpty(item.sgL_ImageTempURL)
                    ? item.jietuFileUrl
                    : item.sgL_ImageTempURL
                );
              })
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.group_card-body_reply {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: 1px;
  padding-right: 10px;
  background-position: 10px top;
  background-image: url("../../../assets/images/group_reply_chat.png");
  background-repeat: no-repeat;
}
.publish-time {
  display: block;
  font-size: 0.575rem;
  color: #757575;
}
.group_feedpost-user {
  background-image: url("../../../assets/images/group_chat.png");
}
.group_self_feedpost-user {
  background-image: url("../../../assets/images/group_chat2.png");
}
.friendlist_user:hover {
  cursor: pointer;
}
.Ingroup_des{margin-top:40px; margin-left:20px; margin-bottom:5px;}
.chat-about {
    padding-top: 0px !important; float: left;  padding-left: 10px;
}

.chat-header>.row {
    align-items: center;
    margin-bottom: 19px;
    padding: 0 17px;
}
.desc_txt {
    color: #c4c4c4;
    text-align: center;
    width: 100%;
}


</style>


// WEBPACK FOOTER //
// src/components/Social/group/groupDetail.vue